import React from 'react';
import styles from './Background.module.scss';

export default function Background() {
  return <div className={styles.labelBackground} />;
}
